import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { peopleEllipsisSx } from "../../peopleFormValidation";

export default function TeamDetailInfoField({ icon: Icon, label, value }) {
  return (
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", minWidth: 0 }}>
      <Box sx={{ flexShrink: 0, lineHeight: 0, marginTop: "-2px" }}>
        <Icon />
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "18px",
            mb: 1,
          }}
        >
          {label}
        </Typography>
        <Typography
          title={value ?? undefined}
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "18px",
            ...peopleEllipsisSx,
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
}
